// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2A8Dj","inputDescription":"styles_inputDescription__1tR_G"};